import { IconProps } from './icons-props';

function PaperclipIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            fill='none'
            width={width}
            height={height}
            className={className}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.3315 21.34C11.2415 21.34 10.1515 20.93 9.3215 20.1C7.6615 18.44 7.6615 15.75 9.3215 14.09L11.8015 11.62C12.0915 11.33 12.5715 11.33 12.8615 11.62C13.1515 11.91 13.1515 12.39 12.8615 12.68L10.3815 15.15C9.3115 16.22 9.3115 17.97 10.3815 19.04C11.4515 20.11 13.2015 20.11 14.2715 19.04L18.1615 15.15C19.3415 13.97 19.9915 12.4 19.9915 10.73C19.9915 9.05998 19.3415 7.48998 18.1615 6.30999C15.7215 3.86999 11.7615 3.86999 9.3215 6.30999L5.0815 10.55C4.0915 11.54 3.5415 12.86 3.5415 14.26C3.5415 15.66 4.0915 16.98 5.0815 17.97C5.3715 18.26 5.3715 18.74 5.0815 19.03C4.7915 19.32 4.3115 19.32 4.0215 19.03C2.7515 17.75 2.0415 16.06 2.0415 14.26C2.0415 12.46 2.7415 10.76 4.0215 9.48998L8.2615 5.24999C11.2815 2.22999 16.2015 2.22999 19.2215 5.24999C20.6815 6.70999 21.4915 8.65998 21.4915 10.73C21.4915 12.8 20.6815 14.75 19.2215 16.21L15.3315 20.1C14.5015 20.93 13.4215 21.34 12.3315 21.34Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default PaperclipIcon;

